import createEnhancedLocations from 'owa-location-persona/lib/utils/createEnhancedLocations';
import { orchestrator } from 'satcheljs';
import { updateLocations, addLocationsFromCommonWell } from 'owa-calendar-compose-form-actions';
import { createLocationMetricsFromPersonas } from 'owa-calendar-forms-utils/lib/utils/createLocationMetrics';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { addLocationMetrics } from 'owa-calendar-compose-form-store/lib/mutators/eventMetricsMutators';
import { updateUnresolvedLocation } from 'owa-calendar-compose-form-store/lib/mutators/composeViewStateMutators';
import fetchRecurrentEventResourcesAvailability from '../utils/fetchRecurrentEventResourcesAvailability';

export default orchestrator(addLocationsFromCommonWell, actionMessage => {
    const newLocations = actionMessage.newLocations;

    const newEnhancedLocations = createEnhancedLocations(
        newLocations.map(location => {
            return location.persona;
        })
    );

    const event = getComposeEvent(null /* formId */);
    updateLocations([...event.Locations, ...newEnhancedLocations]);
    // clear unresolved location on adding a location to store, to be consistent with location picker state
    updateUnresolvedLocation(null);

    const metrics = createLocationMetricsFromPersonas(
        newLocations.map(location => {
            return location.persona;
        })
    );
    addLocationMetrics(metrics);

    // Fetch availability for the resources of recurrent event. This is only for logging for experiment. We fetch the availabilities for all rooms in the Location well
    // using GetRoomAvailability, even when the flight 'cal-mf-availabilityForRecurrence' is off, to compare this availabilities between treatment and control.
    // TODO: Remove this when experiment is over (https://exp.microsoft.com/Rollout?id=f3d8a340-9076-46ee-8db1-d8e17e131b38)
    fetchRecurrentEventResourcesAvailability(event);
});
